export default __webpack_public_path__ + "static/news-img3-636bc6bcbea85c4d89e2524d939c6ac3.png";